import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ShActionItemComponent } from '../../../elements/components/action-item/action-item.component';
import { ShDroppanelSelectComponent } from '../../../elements/components/droppanel-select/droppanel-select.component';
import { ShIconModule } from '../../../elements/components/icon/icon.module';

import { ShClickOutsideDirective } from '../../../elements/directives/click-outside/click-outside.directive';
import { ShFormCheckboxWithDropdownComplexBaseComponent } from './base-complex/form-checkbox-with-dropdown-complex-base.component';
import { ShFormCheckboxWithDropdownBaseComponent } from './base-simple/form-checkbox-with-dropdown-base.component';
import { ShFormCheckboxWithDropdownComponent } from './main/form-checkbox-with-dropdown.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ShActionItemComponent,
        ShIconModule,
        ShDroppanelSelectComponent,
        ShFormCheckboxWithDropdownComponent,
        ShFormCheckboxWithDropdownBaseComponent,
        ShFormCheckboxWithDropdownComplexBaseComponent,
        ShClickOutsideDirective
    ],
    exports: [
        ShFormCheckboxWithDropdownComponent,
        ShFormCheckboxWithDropdownBaseComponent,
        ShFormCheckboxWithDropdownComplexBaseComponent
    ]
})
export class ShFormCheckboxWithDropdownModule {}

export { ShFormCheckboxWithDropdownComplexBaseComponent } from './base-complex/form-checkbox-with-dropdown-complex-base.component';
export { ShFormCheckboxWithDropdownBaseComponent } from './base-simple/form-checkbox-with-dropdown-base.component';
export { ShFormCheckboxWithDropdownComponent } from './main/form-checkbox-with-dropdown.component';
